import * as React from 'react';

class ThreeShape extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let success = this.props.match.params.success;
        return (
            <h3>
                {success == 1 || success == '1'
                    ? 'This window will be closed automatically within 10 seconds.'
                    : 'Error! Please close this window and try again.'}
            </h3>
        );
    }
}

export default ThreeShape;
